"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PictureFrame = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("../Themes/styled-components"));
var Wrapper = styled_components_1.default('div')(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  padding-top: ", "%;\n"], ["\n  position: relative;\n  width: 100%;\n  padding-top: ", "%;\n"])), function (_a) {
    var scWidth = _a.scWidth, scHeight = _a.scHeight;
    return 100 / (scWidth / scHeight);
});
var Content = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"])));
var PictureFrame = /** @class */ (function (_super) {
    tslib_1.__extends(PictureFrame, _super);
    function PictureFrame() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PictureFrame.prototype.render = function () {
        var _a = this.props, className = _a.className, width = _a.width, height = _a.height, children = _a.children;
        return (React.createElement(Wrapper, { className: className, scWidth: width, scHeight: height },
            React.createElement(Content, null, children)));
    };
    return PictureFrame;
}(React.PureComponent));
exports.PictureFrame = PictureFrame;
exports.default = PictureFrame;
var templateObject_1, templateObject_2;
